/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import capitalize from "./capitalize";
import normalize from "./normalize";
import openToast from "./openToast";
import warning from "./warning";

export const checkField = (value, message) => {
  if (!value) {
    openToast(message, "error");
    return true;
  }
  return false;
};

const checkFormFields = (fields) => {
  let isAllValid = true;
  if (!fields) warning("Fields are not defined");
  let fieldsArray = Object.entries(fields);
  for (const [key, value] of fieldsArray) {
    let valueToCheck = value;
    let message = `${capitalize(key)} is required`;
    if (Array.isArray(value)) { // [value, message]
      valueToCheck = value[0];
      message = value[1];
    }
    if (checkField(valueToCheck, message)) {
      isAllValid = false;
      break;
    }
  }
  return isAllValid;
};

export default checkFormFields;


export const comparePrimitiveFields = (prev, current) => {
  const fields = Object.entries(prev);
  let isExact = true;
  for (const [fieldName, prevValue] of fields) {
    const currentValue = current[fieldName] || current[normalize(fieldName)];
    if (currentValue === undefined) continue
    isExact = normalize(currentValue) === normalize(prevValue)
    if (!isExact) break
  }
  return isExact
}